import { render } from "./KamranAwards.vue?vue&type=template&id=2c6917a3&scoped=true"
import script from "./KamranAwards.vue?vue&type=script&lang=js"
export * from "./KamranAwards.vue?vue&type=script&lang=js"

import "./KamranAwards.vue?vue&type=style&index=0&id=2c6917a3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c6917a3"]])

export default __exports__